export class ListInventoryRequest {
    'sorts';
    'filters';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortResourceBy>",
            "format": ""
        },
        {
            "name": "filters",
            "baseName": "filters",
            "type": "InventoryFilterConditions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventoryRequest.attributeTypeMap;
    }
    constructor() {
    }
}
